import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {
    commentAutosuggestDataSelector,
    commentAutosuggestErrorSelector,
    commentAutosuggestLoadingSelector, commentAutosuggestSearchSelector, commentAutosuggestShouldHideSelector
} from "features/components/comment-field/comment-autosuggest/selectors";
import {
    autosuggestCommentUserSelected
} from "features/components/comment-field/comment-autosuggest/reducer";
import {Icon} from "features/components/icon";
import Text from "features/components/text";
import {__} from "services/i18n";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: commentAutosuggestLoadingSelector(state),
    error: commentAutosuggestErrorSelector(state),
    data: commentAutosuggestDataSelector(state),
    should_hide: commentAutosuggestShouldHideSelector(state),
    search: commentAutosuggestSearchSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    onSelect: autosuggestCommentUserSelected
};

export const CommentAutosuggest = (props) => {
    const {loading, error, data, should_hide, onSelect, search} = props;

    const handleSelect = useCallback((item) => {
        onSelect({
            id: item.id,
            search: search,
            replace: `${item.first_name} ${item.last_name}`
        });
    }, [onSelect, search]);

    const showData = useCallback(() => {
        if(loading || error.inError) return null;
        return data.map(item => <div className="item" onClick={() => handleSelect(item)} key={item.id}>
            <Text size={16}>{item.first_name} {item.last_name}</Text>
        </div>)
    }, [data, error.inError, handleSelect, loading]);

    if(should_hide) return null;
    return <div className="comment-autosuggest">
        {loading && <Icon>loader</Icon>}
        {error.inError && <Text size={16} color={"danger"} align={"center"}>{__(error.error)}</Text>}
        <div>{showData()}</div>
    </div>
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentAutosuggest);